import { modalService } from '@deleteagency/modal';
import { pageLocker } from '@deleteagency/page-locker';
import { Overlay } from 'components/overlay';
import { generateBemCss } from 'general/js/helpers';

const overlay = new Overlay('overlay', 'overlay');

modalService.init({
    onBeforeFirstModalOpen: () => {
        pageLocker.lock('modal');
        overlay.show('modal');
    },
    onAfterLastModalClose: () => {
        pageLocker.unlock('modal');
        overlay.hide('modal');
    },
    defaultModalTemplate: ({ bemList }) => {
        const rootCss = generateBemCss('modal-over', bemList);

        return (`
            <div data-modal class="${rootCss}" aria-hidden="true" role="dialog">
                <div class="modal-over__wrapper" data-modal-wrapper>
                    <button class="modal-over__close" data-modal-close type="button" aria-label="close">
                        <svg 
                            class="modal-over__close-icon" 
                            height="20px" 
                            viewBox="0 0 329.26933 329" 
                            width="20px" 
                            xmlns="http://www.w3.org/2000/svg" 
                            fill="#fff"
                        >
                            <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/>
                        </svg>
                    </button>
                    <div class="modal-over__content" data-modal-content></div>
                </div>
            </div>
        `);
    }
});

export default modalService;
